var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VerifyIdentityError',{staticClass:"md:w-435 md:mx-auto",attrs:{"errorTitle":_vm.$t('common.no_contact_info_found'),"errorBody":_vm.$t('common.contact_health_plan_csr.help', [_vm.helpNumber])}})
}
var staticRenderFns = []

export { render, staticRenderFns }